<template lang="html">
    <p class="main-subheading"><slot></slot></p>
</template>

<script>
export default {
    name: "MainSubheading",
};
</script>

<style scoped>
.main-subheading {
    color: #505050;
    font-size: min(2.5rem, 11vw);
    font-weight: 400;
    line-height: 1;
}
</style>
